/**
 * Controller: RolesPermissionsAddModal
 */
angular.module('acme.view.application.roles.permissions.addModal.controllers', [
  'acme.common.service.api',
  'acme.common.service.helpers'
])
.controller('RolesPermissionsAddModalController', [ '$scope', '$uibModalInstance', 'ApiService', 'HelpersService', 'roleData', 'rolePermissions', function ($scope, $uibModalInstance, ApiService, HelpersService, roleData, rolePermissions) {

    $scope.errors = [];

    $scope.model = [];

    $scope.query = '';

    $scope.init = function() {

      ApiService.permissions.list(HelpersService.getPaginator()).then(function(response) {
        var i, ii,
            j, jj,
            permissions = response.data.payload.list;

        for (i=0,ii=permissions.length;i<ii;i++) {
          for (j=0,jj=rolePermissions.length;j<jj;j++) {
            if (permissions[i].id === rolePermissions[j].id) {
              permissions[i].selected = true;
              break;
            }
          }
        }

        $scope.model = permissions;

      }, function(response) {
        // TODO: Backfill
      });
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.getSelected = function() {
      var i, ii,
          permissions = [],
          mappings = [];

      // Returns only the relationship between user and group
      for (i=0,ii=$scope.model.length;i<ii;i++) {
        if ($scope.model[i].selected) {
          permissions.push($scope.model[i]);
          mappings.push({
            permissionId: $scope.model[i].id,
            roleId: roleData.id
          });
        }
      }

      return { mappings: mappings, permissions: permissions };
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.getSelected());
    };

    $scope.init();

}]);
